import { ThemeColors } from '../../../../tokens/colors/types';
import { BaseDeprecatedColors } from '../../../types';

const deprecatedAppBannerColors = '#198cfb';
const uniqueBackground = '#0A8EFF';
const uniqueForeground = '#1D44D5';
export default (baseColors: ThemeColors): BaseDeprecatedColors => ({
  appBanner: {
    bg: '#f9f9f7',
    bt: baseColors.secondary['50'],
    image: null,
    uniqueBackground,
    uniqueForeground,
  },
  banner: {
    bg: baseColors.blue['90'],
    fg: baseColors.secondary['50'],
    gradient: ['#002C52', '#000D29'],
  },
  deprecatedAppBannerColors,
  rating: baseColors.secondary['50'],
  modalWrapperBackgroundColor: 'rgba(0,0,0,0.8)',
  histogramDisabledBackgroundColor: 'rgba(203,203,203,0.3)',
  trainProductColor: baseColors.purple['50'],
  trainProductBgColor: baseColors.purple['20'],
  flightProductColor: baseColors.blue['50'],
  flightProductBgColor: baseColors.blue['20'],
  lightButtonBgColor: baseColors.secondary['50'],
  darkButtonTextColor: baseColors.neutral['90'],
  advertisementBgColor: baseColors.primary['50'],
  promotional: {
    primary: {
      default: baseColors.primary['90'],
      dark: '#000D29',
    },
    secondary: {
      default: baseColors.secondary['50'],
      dark: baseColors.secondary['90'],
    },
  },
});
